export const INVOICE_TYPE = {
  INVOICE: "INVOICE",
  PAY_APPLICATION: "PAY_APPLICATION",
};
